
/* injects from baggage-loader */

'use strict';

export default class ManageProjectController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

		this.navigation = [{
			title: 'Project',
			items: [{
				title: 'General',
				icon: 'fa-list'
			}, {
				title: 'Documents',
				icon: 'fa-file-o'
			}, {
				title: 'Media',
				icon: 'fa-picture-o'
			}, {
				title: 'Comments',
				icon: 'fa-comment-o'
			}]
		}, {
			title: 'Data',
			items: [{
				title: 'Investments',
				icon: 'fa-usd'
			}, {
				title: 'Analytics',
				icon: 'fa-bar-chart'
			}]
		}];

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/manageProject/manageproject.controller.js